/**
 * The Credits screen's data (Phase 8): generated by the asset pipeline from the license
 * register, so every CC-BY credit line and every CC0 source the game ships is listed from the
 * same rows `assets:check` enforces (BUILD_PLAN section 5).
 */
import { z } from 'zod';
export const CreditEntrySchema = z
    .object({
    /** The file or directory under assets/raw the row covers. */
    file: z.string().min(1),
    author: z.string().min(1),
    sourceUrl: z.string().min(1),
    license: z.string().min(1),
    /** The exact credit text for CC-BY work; null for CC0 and other licenses without a demand. */
    attribution: z.string().nullable(),
})
    .strict();
export const CreditsSchema = z
    .object({
    version: z.literal(1),
    entries: z.array(CreditEntrySchema),
})
    .strict();
//# sourceMappingURL=credits-schema.js.map